var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserFilled = function SvgUserFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M9.89 8.946A3.2 3.2 0 0 1 7.6 10a3.2 3.2 0 0 1-2.29-1.054A3.53 3.53 0 0 1 4.4 6.5c-.017-.91.31-1.79.91-2.446A3.2 3.2 0 0 1 7.6 3c.867.019 1.69.398 2.29 1.054.6.657.928 1.536.91 2.446.018.91-.31 1.79-.91 2.446m-.467 1.928h.417c.91.02 1.774.42 2.404 1.109s.974 1.612.956 2.567v1.138c.007.34-.116.67-.341.917A1.2 1.2 0 0 1 12 17H3.2a1.2 1.2 0 0 1-.858-.395 1.32 1.32 0 0 1-.341-.917V14.55a3.7 3.7 0 0 1 .955-2.568 3.36 3.36 0 0 1 2.405-1.107h.417a4.05 4.05 0 0 0 1.823.437c.63 0 1.253-.15 1.822-.437m9.961-3.14a.547.547 0 0 0 0-.774h.002a.547.547 0 0 0-.774 0l-3.985 3.983-1.8-1.797a.547.547 0 0 0-.773.773l2.186 2.185c.213.214.56.214.773 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserFilled);
export default ForwardRef;